import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;

  margin-block-start: 32px;

  ${theme.breakpoints.up("tablet")} {
    row-gap: 48px;

    margin-block-start: 48px;
  }
`;

export const HeaderLogoAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: center;
`;

export const HeaderLogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const HeaderDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
`;

export const HeaderDescription = styled.div`
  max-inline-size: 680px;
  padding-inline: 40px;

  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;
`;

export const HeaderBottomLineContainer = styled.div`
  display: flex;
  justify-content: center;

  max-inline-size: 1440px;
`;

export const HeaderBottomLine = styled.div`
  inline-size: calc(100vw - 40px);
  block-size: 1px;

  background: #ffffff;

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 1168px;
    margin-inline: auto;
  }
`;
